export const financeKinds: Record<string, string> = {
  recharge: '线下充值', deduct: '平账扣款', freeze: '任务冻结', release: '任务解冻', settlement: '任务结算',
};
export const financeStatuses: Record<string, string> = {
  not_frozen: '未冻结', frozen: '待结算', released: '已解冻', settled: '已结算',
};

/** Parse decimal input without floating-point multiplication or rounding. */
export function parseMoneyMinor(value: string): number | null {
  const normalized = value.trim();
  if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) return null;
  const [whole, fraction = ''] = normalized.split('.');
  const result = Number(`${whole}${fraction.padEnd(2, '0')}`);
  return Number.isSafeInteger(result) && result > 0 ? result : null;
}

export function money(minor: number | null | undefined): string {
  if (minor == null || !Number.isSafeInteger(minor)) return '—';
  const digits = Math.abs(minor).toString().padStart(3, '0');
  const whole = digits.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${minor < 0 ? '−' : ''}¥${whole}.${digits.slice(-2)}`;
}

export function signedMoney(minor: number): string {
  return `${minor > 0 ? '+' : minor < 0 ? '−' : ''}${money(Math.abs(minor))}`;
}

export function safeReceiptURL(value: string): string | null {
  if (!value.trim()) return '';
  try {
    const url = new URL(value.trim());
    return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.toString() : null;
  } catch { return null; }
}

export function financeError(error: unknown): string {
  const e = error && typeof error === 'object' ? error as { status?: number; message?: string } : {};
  if (e.status === 401) return '登录已失效，请重新登录。';
  if (e.status === 403) return '当前账号没有此资金操作的权限。';
  const messages: Record<string, string> = {
    insufficient_balance: '可用余额不足，请刷新余额后核对。平账不能扣除冻结资金。',
    version_conflict: '余额、结算条件或配置已更新，请刷新后重新核对。',
    finance_conflict: '资金状态或操作内容已变化，请刷新余额、结算预览或流水后重新核对。',
    idempotency_conflict: '该操作已提交且内容发生变化，请刷新流水核对结果。',
    settlement_blocked: '任务尚未满足结算条件，请刷新预览查看原因。',
    invalid_input: '金额、原因或关联信息不合法，请检查填写内容。',
    invalid_finance_input: '金额、原因、凭证或关联信息不合法，请检查填写内容。',
    invalid_request: '输入不合法，请检查填写内容。',
    not_found: '记录不存在或已不可访问。',
    forbidden: '当前账号或任务状态不允许此操作。',
    network_error: '网络连接失败，请重试；资金操作请保留当前内容重试或先查看流水确认结果。',
    request_timeout: '请求超时，暂时无法确认结果。请保留当前内容重试或先查看流水确认结果。',
  };
  if (messages[e.message ?? '']) return messages[e.message ?? ''];
  if (e.status === 409) return '数据已发生变化，请刷新后重新核对。';
  return '请求失败，请稍后重试。资金操作失败时请先核对流水，避免重复录入。';
}
